import { render, staticRenderFns } from "./migr_detail.vue?vue&type=template&id=631256e2&scoped=true&"
import script from "./migr_detail.vue?vue&type=script&lang=js&"
export * from "./migr_detail.vue?vue&type=script&lang=js&"
import style0 from "./migr_detail.vue?vue&type=style&index=0&id=631256e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631256e2",
  null
  
)

export default component.exports